<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <!--loading overlay-->
      <v-skeleton-loader
        v-if="overlay"
        class="pt-4 d-print-none"
        max-width="800"
        type="heading"
      ></v-skeleton-loader>
            
      <template v-if="!overlay && judgment_exists">
        <div v-for="(casenos, u_title) in displayedTitle" v-bind:key="u_title" class="pt-2">
          <span class="text-h4 casetitle pb-3 mb-0">{{u_title}} </span>
          <span 
            v-for="caseno in casenos" v-bind:key="caseno"
            class="caseno-title pl-1"
          >
            {{caseno}}
          </span>
          <span class="lsidebg px-1 link--text" style="cursor:pointer;" @click="toogleShowTitle" v-if="!showAllTitle">...</span>          
        </div>
        <!-- button to show/hide titles-->
        <v-btn 
          v-if="Object.keys(consol_title).length > 1" 
          @click="toogleShowTitle" 
          small color="lsidebg"  elevation="0"
          class="mt-3 d-print-none link--text"
        >
          <span v-if="showAllTitle"> {{$t('btntxt.case_collapsetitle')}}</span>
          <span v-else> {{$t('btntxt.case_showalltitle')}} ({{Object.keys(consol_title).length}}) </span>
        </v-btn>  
      </template>
    </template>

    <template v-slot:leftPanel>
      <!--Case Info Card-->
      <InfoTable v-if="!overlay"
        :titleText="$t('database.wdg_jdg')"
        :tableContent="infoTableContent"
        :contentType="'l_case'"
      />

      <JudgmentInfoBox v-if="!overlay && infoBoxInfo && infoBoxInfo.info_box"
        :infoBoxInfo="infoBoxInfo"
      />

      <!--Downloads Card-->
      <DownloadWidget v-if="judgment_exists"
        :doc="doc"
        :docname="$t('database.judgment')"
        doctype="MS Word"
        :printable="Boolean(doc)"
        :corrs="corrs"
      />

      <!--Reading Options Card-->
      <v-card id="readopcard" 
        class="pb-2 mb-3 d-print-none lside-wdgt" 
        v-if="!overlay" 
        max-width="350" width="100%" color="lsidebg"  flat
      > 
          
        <v-card-title class="pt-2 pb-1 pl-2">
          <h5 class="wdgt-title ">{{$t('database.wdg_viewops')}} </h5> <!--darkgrey--text-->
        </v-card-title>

        <v-card-actions class="pl-4 pb-1 d-flex flex-wrap" >
          <!--case summary for PI cases-->
          <v-tooltip v-if="textSummaryAvailable" color="liiblack lighten-1" max-width="300" right :disabled="trans">
            <template v-slot:activator="{ on, attrs }">
              <v-row no-gutters align="start">
                <v-btn
                  dense small color="link white--text" elevation="0"
                  v-bind="attrs" v-on="on" 
                  class="mr-2 mb-2"
                  :href="`${synopsisSiteUrl}/?nc=${neutral}`"
                  target="_blank"
                >
                  <v-icon class="mr-2" small color="white">mdi-file-find</v-icon>
                  {{$t('home.case_summary')}}
                </v-btn>
                <div class="d-inline-flex mb-2">
                <router-link to="/news#casesummary" >
                  <span class="beta-tag link--text" >{{$t('btntxt.newfeature')}}</span>
                </router-link>
                </div>
              </v-row>
            </template>
            <span> {{$t('home.case_summary_desc')}}</span>
          </v-tooltip>
          
          <!--translation-->
          <v-tooltip color="liiblack lighten-1" right :disabled="trans">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dense outlined small color="link" 
                :disabled="!trans"
                v-bind="attrs" v-on="on"
                :to="trans_path" 
                class="mb-2 mr-2">
                {{$t('database.wdg_translation')}} <!--Original/translation {{lang}}-->
              </v-btn>
            </template>
            <span> {{$t('database.wdg_viewops_trans')}}</span>
          </v-tooltip>

          <!--highlight-->
          <v-tooltip color="liiblack lighten-1" right :disabled="content_hl==''">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dense outlined small color="link" 
                :disabled="content_hl==''"
                v-bind="attrs" v-on="on"
                @click="show_hl=!show_hl"
                class="mb-2 mr-2">
                {{$t('btntxt.togglehl')}}
              </v-btn>
              </template>
            <span> {{$t('database.togglehl_hint')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <!--Appeal History Card-->
      <v-card v-if="!overlay " id="appealhistcard" class="mb-3 pb-2  d-print-none lside-wdgt" max-width="350" width="100%" color="lsidebg" flat>
        <v-card-title class="pt-2 pb-1 pl-2">
          <h5 class="wdgt-title ">{{$t('database.appealhis', [has_appeal ? $t('database.appeal') : $t('database.case_a')])}} </h5>
        </v-card-title>

        <v-card-text class="pb-1 pl-5 pt-0 "> <!--class="text-right"-->
          <div v-for="ah in appealhistories" :key="ah.text">
            <router-link :to="{name: ah.link.name, params: ah.link.params}" class="apphislink"> 
              {{ah.text}}
            </router-link>
          </div>
        </v-card-text>
      </v-card>

    </template>

    <template v-slot:mainPanel>

      <!--loading overlay-->
      <v-skeleton-loader
        v-if="overlay"
        max-width="800"
        type="divider, paragraph@2 "
        class="d-print-none"
      ></v-skeleton-loader>

      <v-divider v-if="judgment_exists"></v-divider>

      
      <!--Alerts for Word only Corrigendum-->
      <v-alert v-if="!overlay && corrs.length>0 && !corrs[0].content "
        dense text
        type="warning"
        class="mt-6 mb-4"
        icon="mdi-alert-circle-outline"
      > 
        {{$t('error.case_onlyword')}} <!--new warning-->
      </v-alert>

      <!--Corrigendum-->
      <div class="case-content" v-for="corr in corrs" v-bind:key="corr.id" @click="content_clicked">
        <div v-html="show_hl&&$route.query.hl?corr.content_hl:corr.content"></div>
        <v-divider v-if="!overlay" class="mt-2"></v-divider>
      </div>
      
      <!--Judgment Content-->
      <div v-if="content" class="case-content" v-html="show_hl&&$route.query.hl?content_hl:content" @click="content_clicked"></div>

      <!--Alerts for Missing Judgment Content-->
      <v-alert v-if="!overlay && judgment_exists && !content "
        dense text
        type="warning"
        class="mt-6 mb-4"
        icon="mdi-alert-circle-outline"
      > 
        {{$t('error.case_onlyword')}} 
      </v-alert>
      <v-alert v-if="!overlay && !judgment_exists"
        dense text
        type="error"
        class="mt-3 mb-4"
        icon="mdi-alert-outline"
      > 
        {{$t('error.case_unavailable')}}
      </v-alert>
    </template>

    <template v-slot:rightPanel v-if="judgment_exists">
      <!--References Card-->
      <v-card id="refcard" flat class="rsidecard mb-4 mr-3 pb-3" max-width="350" min-width="250" width="100%" > 
          
        <v-card-title class="mb-1">
          <h5 class="wdgt-title"> {{$t('database.wdg_ref_c')}} </h5>
        </v-card-title>

        <v-card-text>
          <v-tooltip top color="liiblack lighten-1">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <v-btn 
                  dense small outlined block
                  color="navlink" 
                  v-if="judgment_exists" :href="lawcite_path" 
                  class="mb-3"
                  >
                  Lawcite
                </v-btn>
              </div>
            </template>
            <span>{{$t('database.wdg_ref_lawcite')}}</span>
          </v-tooltip>

          <v-tooltip color="liiblack lighten-1" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <v-btn 
                  dense small block elevation="0"
                  color="primary text--white" 
                  :to="noteup_route"
                  >
                  Noteup
                </v-btn>

              </div>
            </template>
            <span>{{$t('database.wdg_ref_noteup')}}</span>
          </v-tooltip>
        </v-card-text>
      </v-card>

      <JudgmentTagging
        v-if="synopsisTags.w2v_tags.length+synopsisTags.bert_tags.length>0"
        :primaryTags="synopsisTags.w2v_tags"
        :secondaryTags="synopsisTags.bert_tags"
      />
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import InfoTable from '@/components/InfoTable'
  import DownloadWidget from '@/components/DownloadWidget'
  import JudgmentTagging from '@/components/synopsis/JudgmentTagging'
  import JudgmentInfoBox from '@/components/synopsis/JudgmentInfoBox'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  import scrollhelper from '@/scripts/scrollhelper'
  import highlighthelper from '@/scripts/highlighthelper'
  export default {
    name:'Case',
    components:{
      ThreeColumn,
      InfoTable,
      DownloadWidget,
      JudgmentTagging,
      JudgmentInfoBox
    },
    data(){
      return {
        dialog: false,
        overlay: true,
        neutral: '',
        citation: [],
        cases: [],
        date: '',
        show_hl: true,  // show highlight
        content: '',
        content_hl: '',  // content highlight
        doc: '',
        corrs: [],
        trans: false,
        lawcite_path: '',
        judgment_exists: false,
        showAllTitle: true,
        appealhistories: [],
        has_appeal: false,
        infoBoxInfo: null,
        textSummaryAvailable: false,
        synopsisTags: {bert_tags: [], w2v_tags: []},
        synopsisSiteUrl: process.env.VUE_APP_SYNOPSIS_URL,
      }
    },
    methods:{
      content_clicked: scrollhelper.content_clicked,
      get_case_params(caseno){
        let match = /([A-Za-z]+)(\d+)\/(\d+)/.exec(caseno)
        if(match){
          return {
            'name': 'appeal-history',
            'params': {
              'type': match[1],
              'year': match[3],
              'num': match[2] 
            }
          }
        } else {
          return ''
        }
      },
      citation_sort_func(a, b){
        const reg = /([a-zA-Z]+)(\d+)\/(\d+)/  // example: FACC8/2017
        var matcha = reg.exec(a)  // [full_match, judgment_type, number, year]
        var matchb = reg.exec(b)
        if(matcha.length == 0 || matchb.length == 0){
          // one of the action number is not in the canonical form
          return matcha.length - matchb.length
        } else {
          if (matcha[1] != matchb[1]){
            // different judgment type
            return matcha[1].localeCompare(matchb[1])
          } else if (matcha[3] != matchb[3]) {
            // same judgment type
            return parseInt(matcha[3]) - parseInt(matchb[3])
          } else {
            // same judgment type and year
            return parseInt(matcha[2]) - parseInt(matchb[2])
          }
        }
      },
      sort_cases(cases){
        if(cases.length > 0){
          return cases.sort((case1, case2) => {
            return this.citation_sort_func(case1.act, case2.act)
          })
        } else {
          return []
        }
      },
      async get_case(){
        const params = this.$route.params
        try {
          const res = await api.get_judgment(params.lang, params.abbr, params.year, params.num)
          this.cases = this.sort_cases(res.cases)
          this.date = datehelper.display_date(res.date)
          this.neutral = res.neutral
          this.citation = res.parallel_citation || []
          this.trans = res.has_translation
          this.doc = res.doc
          this.content = res.content
          this.db = res.db
          this.corrs = res.corrs ? res.corrs.sort((corra, corrb) => {
            // if corrb.cnt > corra.cnt, then corrb sort before corra (larger cnt goes first)
            return corrb.cnt - corra.cnt
          }) : null
          if (this.$route.query.hl){
            this.content_hl = highlighthelper.hlBody(this.content, this.$route.query.hl)
            this.corrs.forEach(corr => {
              corr.content_hl = highlighthelper.hlBody(corr.content, this.$route.query.hl)
            })
          }
          this.lawcite_path = `http://www.austlii.edu.au/cgi-bin/LawCite?cit=${params.year} ${params.abbr} ${params.num}`
          
          //window.document.title = Object.keys(this.consol_title)[0] + ' | HKLII'
          this.judgment_exists = true
          scrollhelper.scroll_to_anchor(this.$route.hash)
          
          // Synopsis: info box, tags
          this.makeInfoBoxInfo()
          this.makeSynopsisTags()
          this.checkTextSummaryAvailability()

          // forming case / appeal history
          var distinct_actno = [...new Set(this.cases.map(c => c.act))]
          this.appealhistories = distinct_actno.map(act => {
            return {
              text: act,
              link: this.get_case_params(act)
            }
          })
          
          // check has_appeal
          await Promise.any(this.appealhistories.map(ah => {
            return new Promise((resolve, reject) => {
              api.get_appeal_history(ah.text).then(res => {
                res.length > 1 ? resolve() : reject()
              })
            })
          })).then(() => this.has_appeal = true, () => this.has_appeal = false)
        } catch(err) {
          console.error(err)
          this.judgment_exists = false
        } finally {
          this.overlay = false
        }
      },
      toogleShowTitle(){
        this.showAllTitle =!this.showAllTitle
      },
      async makeSynopsisTags(){
        try {
          this.synopsisTags = await api.get_judgment_tags(this.neutral)
        } catch (err) {
          console.error(err)
        }
      },
      async makeInfoBoxInfo(){
        try {
          this.infoBoxInfo = await api.get_info_box(this.neutral)
        } catch (err) {
          console.error(err)
        }
      },
      async checkTextSummaryAvailability(){
        try {
          const res = await api.get_summary_availability(this.neutral)
          this.textSummaryAvailable = res.is_available
        } catch (err) {
          console.error(err)
        }
      }
    },
    computed:{
      paths(){
        if (this.judgment_exists){
          return  [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: this.db, disabled: false, href: {name:'case-db', params:this.$route.params}},
            {text: this.neutral, disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: '/'},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
      trans_path(){
        if(this.$route.params['lang'] == 'en'){
          return this.$route.path.replace('en', 'tc')
        } else {
          return this.$route.path.replace('tc', 'en')
        }
      },
      consol_title(){
        var result = Object()
        this.cases.forEach(c => {
          var trimmed_title = c.title.trim()
          if (trimmed_title in result){
            result[trimmed_title].push(c.act)
          } else {
            result[trimmed_title] = [c.act]
          }
        });
        return result
      },
      infoTableContent(){
        var content = [
          {name: this.$t('database.date'), value: this.date},
        ]
        if (this.cases){
          var distinct_actno = this.appealhistories.map(ah => {return {text: ah.text}})
          content.push({name: this.$t('database.action'), value: distinct_actno})
        }
        if (this.neutral){
          content.push({name: this.$t('database.wdg_jdg_neutral'), value: this.neutral})
        }
        if (this.citation.length > 0){
          var pc = this.citation.map(citation => {return {text: citation}})
          content.push({name: this.$t('database.wdg_jdg_pcit'), value: pc})
        }
        return content
      },
      displayedTitle(){
        if(this.showAllTitle && Object.keys(this.consol_title).length > 1){
          return this.consol_title
        } else {
          var result = {}
          var first_title = Object.keys(this.consol_title)[0]
          result[first_title] = []  // when title is collapsed, we hide the case number
          return result
        }
      },
      noteup_route(){
        return {
          name: 'case-noteup',
          query: {
            'abbr': this.$route.params.abbr,
            'year': this.$route.params.year,
            'num': this.$route.params.num
          }
        }
      }
    },
    watch:{
      '$route': function(){
        this.get_case()
      }
    },
    beforeMount(){
      this.get_case()
    },
    updated(){
      this.$nextTick(() => {
        scrollhelper.scroll_to_anchor(this.$route.hash)
      })
    },
    metaInfo(){
      return{
        title: Object.keys(this.consol_title)[0] + " | " + this.neutral || 'Judgment',
        meta: [
        {
          name: 'description',
          content: 'Judgment of ' + this.neutral + ' | ' + this.appealhistories.map(ah => {return ah.text})  + " | " + Object.keys(this.consol_title) ,
        }
      ],
      }
    },
  }
</script>

<style scoped lang="scss">
@import '@/sass/_typography.scss';

  .caseno-title{
    color: var(--v-footergrey-darken2);
    font-size: 10pt !important;
  }

  .case-content{
    width:95%;
    margin:10px auto;
  }

  /*******formatting for Judgment*******/
  .case-content ::v-deep a {
    color: var(--v-link-base);
  }

  .case-content ::v-deep .para, .case-content ::v-deep .pseudopara{  /*pseudopara for [1997] HKCFI 183 (cases pre 1997)*/
    color: var(--v-primary-base);
    font-weight: 700; 
    font-size: 11pt;
    padding-right:0.56em;
    font-feature-settings: 'tnum';
    -webkit-font-feature-settings: 'tnum';
    -moz-font-feature-settings: 'tnum';
  }

  .case-content ::v-deep .auto-style1{ /*special case in [2012] HKDC 1, font is times*/
    font-family: inherit !important;
  }
  .case-content ::v-deep font[face='Times New Roman']{/*[2000] HKCFI 601,  font is times*/
    font-family: $body-font !important;
  }
  .case-content ::v-deep kbd{ /*keyboard input used in [1997] HKCFI 806*/
    background: none;
    color: rgba(0,0,0,.95);
    padding: 0px 0px;
    font-size: 100%;
    font-weight: 500;
    font-family: $body-font;
  }

  @media print{
    .case-content{
      font-size: 9.5pt;
    }
    .case-content ::v-deep .para{
       font-size: 9pt;
    }
  }

/*****spacing for Judgments******/
  .case-content ::v-deep blockquote{
    padding-left: 1.76em;
  }

  .case-content ::v-deep p.heading{
    padding-top: 2em;
    font-weight: 600;
  }

  .case-content ::v-deep representation{
    display: block;
    padding-bottom: 4em;
  }

  /*.case-content ::v-deep parties > table>tbody>tr>td:first-child[width="50%"]{ //not sure if bug or feature
    width:5%;
    max-width: 200px;
  }*/

  .case-content ::v-deep table{ 
    margin-bottom: 2em;
  }
  .case-content ::v-deep form[name='search_body']>table{/*prevent table from going outside, outmost wrapper of case-content*/
    table-layout: fixed;
    /*table-layout: fixed;should remove this becase it cased ugly table for [2018] HKMagC 3; but [2021] HKLdT 61 needs it*/
  }
  .case-content ::v-deep table[style*='width:7'], .case-content ::v-deep table[style*='width:8'], .case-content ::v-deep table[style*='width:9']{ /*tables in actual content overflowing when width is defined in [2021] HKLdT 61, limited to tables width 800-999*/
    table-layout: fixed;
    width:100% !important;
    font-size: 0.9em;
     @media print{
       font-size: 8.5pt;
     }
  }
  .case-content ::v-deep div[style*='width']{ /*same overflow issue with divs, see [2021] HKLdT 81,*/
    width:100% !important;
  }
  .case-content ::v-deep table[width*='800px; padding-left:0; padding-right:0;'], .case-content ::v-deep table[style*='width:1100px']{ /*same overflow issue  [2021] HKDC 1540,  [2021] HKLDT 78*/
    font-size: 0.85em;
    width:100% !important;
    @media print{
       font-size: 8.5pt;
     }
  }
  .case-content ::v-deep th, .case-content ::v-deep td{ 
    word-wrap: break-word;
  }
  .case-content ::v-deep img{ /*prevent image from going outside*/
    width: auto !important; /*to remove immesely large images in [2022] hkcfi 2512,[2013] HKCFI 463*/
    max-width: 100% !important; 
    height: auto !important;
  }

  /*remove date overlapping*/
  .case-content ::v-deep date>table>tbody>tr>td:first-child{
    white-space: nowrap;
    /*[2021] HKCFI 3646 colon is wrapped*/
  }
  .case-content ::v-deep date>table>tbody>tr>td[style*='width']{ 
    min-width: 230px !important; /*fix [2022] HKCA 10, [2022] HKCA 6 */
    white-space: normal; /*longer dates would overflow if not normal [2022] HKCFI 251*/
  }

  /************widgets************/
  .apphislink{
    color: var(--v-link-base);
    text-decoration: none;
  }
 .apphislink:hover{
    background-color: var(--v-link-lighten5);
  }
    /* .appeal{
        max-width:90%;
        margin:0 auto;
    } */
    /* .casetitle br{
      possibility to add space-after if the title has line breaks?
       padding-bottom: 5px;
    } */
</style>
